import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import CheckIcon from "@material-ui/icons/Check";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import { graphqlUrl } from "utils/config";
import "./superPeople.css";

/**
 * Shared pieces for the four people screens — customers, drivers,
 * admins and driver verifications. Same role as
 * superAdminViews/ride/detailFields.js and restaurant/shopFields.js:
 * one label/value grid, one copy-field, one star rendering and one
 * document strip instead of four hand-rolled copies.
 */

export const DetailField = ({ label, value, wide }) => {
  if (value === null || value === undefined || value === "") return null;
  return (
    <div className={`superPersonField ${wide ? "isWide" : ""}`}>
      <span className="superPersonLabel">{label}</span>
      <span className="superPersonValue">{value}</span>
    </div>
  );
};

export const CopyableField = ({ label, value, wide }) => {
  const [copied, setCopied] = useState(false);
  if (!value) return null;

  const handleCopy = () => {
    if (!navigator.clipboard) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <div className={`superPersonField ${wide ? "isWide" : ""}`}>
      <span className="superPersonLabel">{label}</span>
      <span className="superPersonValueRow">
        <span className="superPersonMono">{value}</span>
        <IconButton size="small" className="superPersonCopyButton" onClick={handleCopy} title="Copy">
          {copied ? <CheckIcon fontSize="small" /> : <FileCopyIcon style={{ fontSize: 16 }} />}
        </IconButton>
      </span>
    </div>
  );
};

export const Stars = ({ value, showValue = true }) => {
  if (value === null || value === undefined || value === 0) {
    return <span className="superPersonMuted">Not rated</span>;
  }
  const rounded = Math.round(value);
  return (
    <span className="superPersonRating">
      <span className="superPersonStars">
        {[1, 2, 3, 4, 5].map((star) =>
          star <= rounded ? <StarIcon key={star} /> : <StarBorderIcon key={star} className="isEmpty" />
        )}
      </span>
      {showValue && <span className="superPersonRatingValue">{Number(value).toFixed(1)}</span>}
    </span>
  );
};

export const ImageStrip = ({ label, urls, wide }) => {
  const list = (urls || []).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className={`superPersonField ${wide ? "isWide" : ""}`}>
      <span className="superPersonLabel">{label}</span>
      <span className="superPersonImages">
        {list.map((url, index) => (
          <a
            key={`${url}-${index}`}
            className="superPersonImageButton"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            title="Open full size"
          >
            <img src={url} alt={`${label} ${index + 1}`} />
          </a>
        ))}
      </span>
    </div>
  );
};

export const Avatar = ({ name, url }) => (
  <span className="superPersonAvatar">
    {url ? <img src={url} alt="" /> : (name || "?").trim().charAt(0).toUpperCase()}
  </span>
);

export const assetUrl = (path) =>
  !path ? null : /^https?:\/\//i.test(path) ? path : `${graphqlUrl}${path.startsWith("/") ? "" : "/"}${path}`;

export const readableError = (error) => {
  if (!error) return "Something went wrong.";
  if (error.graphQLErrors && error.graphQLErrors.length > 0) return error.graphQLErrors[0].message;
  return error.message || "Something went wrong.";
};

export const humanize = (value) => (value ? String(value).replace(/_/g, " ").toLowerCase() : "");
